import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/round creams/round orange biscuit.png";
import BiscuitImg from "../../../assets/products/round creams/Round-Orange.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 13,
  },
  {
    grams: 18,
  },
  {
    grams: 20,
  },
  {
    grams: 30,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 70,
  },
  {
    grams: 90,
  },
];

export default function OrangeRoundProduct() {
  return (
    <>
      <Helmet>
        <title>
          Round Orange Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Round Orange Cream Biscuits — zesty orange-flavored sandwich biscuits with smooth cream filling. Perfect for tea-time and global export."
        />
        <meta
          name="keywords"
          content="Round Orange Cream Biscuit, BearBitz Orange Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/round-cream-biscuit/round-orange"
        />
        <meta
          property="og:title"
          content="Round Orange Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Zesty orange-flavored round cream biscuits with export-ready specs and premium taste."
        />
      </Helmet>

      <ProductTemplate
        productTitle="ORANGE"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#EF5608"
        sectionBgColor="#FFDAC8"
        productBgcolor="#FEB088"
        tableheadBgcolor="#EF5608"
        tableBgcolor="#FFF1EA"
        footerBgcolor="#EF5608"
      />
    </>
  );
}
